import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取角色信息*/
export function GetRole(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/role/",
        params:data
    })
}

/*获取角色编辑信息*/
export function RoleEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/roleedit/",
        params:data
    })
}

/*角色编辑*/
export function RoleEdit(data = {}){
    let params = new URLSearchParams();
    params.append('roleid',data.roleid);
    params.append('rolename',data.rolename);
    params.append('roledescription',data.roledescription);
return instance.request({
        method: "post",
        url: "lzjaiopsbase/roleedit/",
        data:params
    })
}

/*角色新增*/
export function RoleAdd(data = {}){
    let params = new URLSearchParams();
    params.append('rolename',data.rolename);
    params.append('roledescription',data.roledescription);
return instance.request({
        method: "post",
        url: "lzjaiopsbase/roleadd/",
        data:params
    })
}

/*角色删除*/
export function RoleDel(data = {}){
    let params = new URLSearchParams();
    params.append('roleid',data.roleid)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/roledel/",
        data:params
    })
}

/*功能授权确认*/
export function FunctionAuthorizationConfirm(data = {}){
    let params = new URLSearchParams();
    params.append('roleid',data.roleid)
    params.append('authList',data.authList)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/functionauthorization/",
        data:params
    })
}

/*获取授权功能列表*/
export function AuthorizationInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/functionselected/",
        params:data
    })
}

/*获取授权功能信息*/
export function FunctionAuthorization(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/functionauthorization/",
        params:data
    })
}

/*获取所有功能信息*/
export function FunctionInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/functiontree/",
        params:data
    })
}